import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponentOutlined';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUserOutlined';
import SettingsInputHdmiIcon from '@mui/icons-material/SettingsInputHdmi';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { useTranslation } from 'react-i18next';
import { Paths } from '../../../shared/paths';
import { useStyles } from './Menu.styles';
import theme from '../../../styles/theme';
import { useAccess } from '../../../hooks/useAccess';
import { Typography } from '@mui/material';

interface IMenuItem {
  icon: ReactNode;
  label: string;
  link: string;
  counter?: number;
  hasAccess?: () => boolean;
  activeKye: string;
}

const Menu = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { loading, access } = useAccess();

  // const { unreadMessages, isHasPermissions } = useGlobal();
  // const messagesCount = _.chain(unreadMessages)
  //   .values()
  //   .map((item) => item.length)
  //   .sum()
  //   .value();
  const { classes } = useStyles(theme);

  const menuItems: IMenuItem[] = [
    {
      icon: <PersonIcon />,
      label: t('common.myProfile'),
      link: Paths.root,
      activeKye: '',
    },
    {
      icon: <SettingsInputComponentIcon />,
      label: t('menu.moderatorDashboard'),
      link: Paths.moderatorDashboard.root,
      hasAccess: () => access?.adminPanels?.canViewModeratorPanel ?? false,
      activeKye: 'moderator',
    },
    {
      icon: <SettingsInputHdmiIcon />,
      label: t('menu.adminDashboard'),
      link: Paths.adminDashboard.root,
      hasAccess: () => access?.adminPanels?.canViewAdminPanel ?? false,
      activeKye: 'admin',
    },
    {
      icon: <VerifiedUserIcon />,
      label: t('menu.superAdminDashboard'),
      link: Paths.superAdminDashboard.root,
      hasAccess: () => access?.adminPanels?.canViewSuperAdminPanel ?? false,
      activeKye: 'superadmin',
    },
  ];

  function isActiveTab(item: IMenuItem) {
    if (item.link === Paths.root) return location.pathname === item.link;

    return location.pathname.split('/').filter(Boolean)[0] === item.activeKye;
  }

  const filteredMenuItems = menuItems.filter(
    (item) => !item.hasAccess || item.hasAccess(),
  );

  return (
    <nav className={classes.menuWrapper}>
      <div className={classes.menuContainer}>
        <ul>
          {filteredMenuItems?.map((item) => (
            <React.Fragment key={item.label}>
              <Link to={item.link} className={classes.menuItemLink}>
                <li
                  className={clsx(
                    classes.menuItem,
                    isActiveTab(item) && classes.active,
                  )}>
                  {item.icon}
                  <Typography variant="text-lg">{item.label}</Typography>
                  {/*{!!item.counter && (*/}
                  {/*  <span className={classes.counter}>*/}
                  {/*    {item.counter < 100 ? item.counter : '99+'}*/}
                  {/*  </span>*/}
                  {/*)}*/}
                  <ArrowForwardIosIcon />
                </li>
              </Link>
            </React.Fragment>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Menu;
